<template lang='pug'>
div(:class='$style[`cc-team-profile`]')
  div(:class='$style[`cc-team-profile-wrap`]')
    div(:class='$style[`cc-team-profile-basic`]')
      figure(:class='$style[`cc-team-profile-avatar`]')
        img(:src='avatarSrcLink(dataTeam.thumbSrc)' width='100%' height='100%')
      div(:class='$style[`cc-team-profile-status`]')
        div(:class='$style[`cc-team-profile-status-wrap`]')
          span.font-medium(:class='$style[`cc-team-profile-status-name`]') {{ dataTeam.name }}
          span(:class='$style[`cc-team-profile-status-type`]') {{ dataTeam.npo_type }}

        div(:class='$style[`cc-team-profile-status-controller`]')
          div(:class='[$style[`cc-team-profile-status-controller-btn`], $style[bookmarkToggle ? `cc-team-profile-nav-btn-fill` : ``]]' @click='handleTeamAddBookMark')
            transition(name='animate-slide-up-fade')
              div(
                v-if='bookmarkTipToggle'
                :class='$style[`cc-team-profile-status-controller-tip`]')
                span!= '已收藏'
            IconBookMark(:size='22' :color='bookmarkToggle ? `#98a1a1` : `#b1b1b1`')
            span {{ bookmarkToggle ? '已收藏' : '收藏' }}

          div(:class='$style[`cc-team-profile-status-controller-btn`]' @click='handleShowQRcodePopBox')
            IconShare(:size='22' :color='`#b1b1b1`')
            span {{ '分享' }}

    div(:class='$style[`cc-team-profile-detail`]')
      ul(:class='$style[`cc-team-profile-detail-ul`]')
        li(v-if='dataTeam.email' :class='$style[`cc-team-profile-detail-li`]')
          IconMail(:size='22' :color='`#b1b1b1`')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`mailto:${dataTeam.email}`') {{ dataTeam.email }}
        li(v-if='dataTeam.web' :class='$style[`cc-team-profile-detail-li`]')
          IconLink(:size='22' :color='`#b1b1b1`')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.web}`')!= '前往官網'
        li(v-if='dataTeam.fb' :class='$style[`cc-team-profile-detail-li`]')
          IconFacebook(:size='22')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.fb}`')!= '臉書專頁'
        li(v-if='dataTeam.youtube' :class='$style[`cc-team-profile-detail-li`]')
          IconYoutube(:size='22')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.youtube}`')!= 'Youtube'
        li(v-if='dataTeam.line' :class='$style[`cc-team-profile-detail-li`]')
          IconLine(:size='22')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.line}`')!= 'Line官方帳號'
        li(v-if='dataTeam.podcast' :class='$style[`cc-team-profile-detail-li`]')
          IconMic(:size='22' :color='`#b1b1b1`')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.podcast}`')!= 'Podcast'
        li(v-if='dataTeam.ios' :class='$style[`cc-team-profile-detail-li`]')
          IconIos(:size='22' :color='`#b1b1b1`')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.ios}`')!= 'iOS APP下載'
        li(v-if='dataTeam.android' :class='$style[`cc-team-profile-detail-li`]')
          IconAndroid(:size='22' :color='`#b1b1b1`')
          a(:class='$style[`cc-team-profile-detail-link`]' :href='`${dataTeam.android}`')!= 'Android APP下載'


</template>

<script>
// import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import { useShare } from '@vueuse/core'
const { share, isSupported } = useShare();

import { debounce } from 'debounce';
// import { mixin as clickaway } from 'vue-clickaway';

import {
  postAddTeamBookmark,
  deleteTeamBookmark,
} from '../../../js/restapi';

import IconMail from '../../icon/Mail';
import IconLink from '../../icon/Link';
import IconFacebook from '../../icon/Facebook';
import IconYoutube from '../../icon/Youtube';
import IconMic from '../../icon/Mic';
import IconShare from '../../icon/Share';
import IconLine from '../../icon/Line';
import IconIos from '../../icon/Ios';
import IconAndroid from '../../icon/Android';
import IconLoading from '../../icon/Loading';
import IconDelete from '../../icon/Delete';
import IconBookMark from '../../icon/Bookmark';

export default {
  components: {
    IconMail,
    IconLink,
    IconFacebook,
    IconYoutube,
    IconMic,
    IconShare,
    IconLine,
    IconIos,
    IconAndroid,
    IconDelete,
    IconLoading,
    IconBookMark,
  },

  props: {
    dataTeam: {
      type: Object,
      default: null,
    },
    tmid: {
      type: String,
      default: '',
    },
    isBookmarked: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      bookmarkToggle: this.isBookmarked,
      bookmarkTipToggle: false,
      // infiniteId: +new Date(),
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      // changeQRcodeStatus: 'global/POPQRCODE_STATUS',
    }),

    handleShowQRcodePopBox() {
      share({
        title: 'Cancell醫抗癌 公益單位',
        text: '公益單位',
        url: `https://cancell.tw/team/${this.tmid}`,
      });
    },

    // handleShowQRcodePopBox() {
    //   this.changeQRcodeStatus({
    //     active: true,
    //     link: `https://cancell.tw/team/${this.tmid}`,
    //   });
    // },

    handleTeamAddBookMark() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.bookmarkToggle = !this.bookmarkToggle;
        this.bookmarkDebounceEvent({
          isAdded: this.bookmarkToggle,
        });
      }
    },

    // eslint-disable-next-line func-names
    bookmarkDebounceEvent: debounce(function (e) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const UPDATE_DATA = {
        auth_id: `${this.loginDjangoId}`,
        npo_id: `${this.tmid}`,
      };

      this.bookmarkTipToggle = false;

      if (e.isAdded) {
        postAddTeamBookmark('', UPDATE_DATA, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((/* response */) => {
            this.bookmarkTipToggle = true;
            // this.$emit('sendBookmarkState', true);
            // this.handleUserAddHp(this.loginDjangoId, '+1');
            console.log('%c 新增書籤 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
          })

          .catch((error) => {
            console.error('新增書籤 失敗！', error.message);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      } else {
        // eslint-disable-next-line no-undef
        deleteTeamBookmark('', {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
          data: JSON.stringify(UPDATE_DATA),
        })
          .then((/* response */) => {
            // this.$emit('sendBookmarkState', false);
            // this.handleUserAddHp(this.loginDjangoId, '-1');
            console.log('%c 刪除書籤 成功', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
          })

          .catch((error) => {
            console.error('刪除書籤 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      }
    }, 300),

  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/team/teamProfile.scss';
</style>
